import { render, staticRenderFns } from "./notification-types.vue?vue&type=template&id=1dc29e82&"
import script from "./notification-types.vue?vue&type=script&lang=js&"
export * from "./notification-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports